module.exports = __webpack_public_path__ + "static/media/coastal-grandma.54b2390b.png";